import React, {useEffect} from "react";
import './AnalizaMain.css';
import {Link, useHistory} from "react-router-dom";
import MathJax from 'react-mathjax-preview'
import TeX from "@matejmazur/react-katex";
import * as BiIcons from "react-icons/bi";

export default function SzeregiLiczbowe(){

    useEffect(()=>{
        document.title="Szeregi liczbowe";
    },[])

    const szeregHarm = '`sum_(n=1)^infty (n+1)/n^a`';
    const szeregGeo = '`sum_(n=1)^infty aq^(n-1)   lub   a+aq+aq^2+...+aq^(n-1)`';

    const { push } = useHistory();

    const comeBackFunc=()=>{
        push('/analiza/pojecia-wstepne');
    }


    return(
        <div className='conceptsContainer'>
            <div className='comeBackDiv' onClick={comeBackFunc}>
                <BiIcons.BiArrowBack/>
                <div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
            </div>

            <h1>Nieskończony szereg liczbowy</h1>
            <p className='oneLine centerVertical'>Oznaczamy go symbolem:
                &nbsp;<MathJax math={'`sum_(n=1)^infty ((1),(.)) lub u_1+u_2+...+u_n+...`'}/>
            </p>
            <br/><br/>
            <p>Suma szeregu: <TeX math={'s_n=u_1+u_2+...+u_n'}/>,  gdzie <TeX math={'u_1, u_2, ...'}/> - to wyrazy szeregu,
            a <TeX math={'u_n'}/> - to wyraz ogólny szeregu.
            </p>
            <br/><br/>
            <p>
                Jeżeli ciąg sum cząstkowych jest zbieżny, tzn. ma skończoną granicę s, to mówimy, że szereg jest zbieżny, a sumą
                szeregu nieskończonego jest liczba s. Oznaczamy to:
                {/*&nbsp;<div className='column'><sup className='nospace'>&#8734;</sup> &#8721; <sub>n=1</sub></div>
                u<sub><small>n</small></sub> = s.*/}
            </p>
            <p><MathJax math={'`sum_(n=1)^infty (n+1)/n^a`'}/></p>
            <p>Jeżeli szereg nie jest zbieżny, to mówimy, że jest to szereg rozbieżny.</p>
            <br/>
            <p className='oneLine centerVertical'>Głównym i koniecznym warunkiem zbieżności każdego szeregu</p>
            <p><MathJax math={'`sum_(n=1)^infty u_n`'}/></p>
            <p>jest to, żeby wyraz ogólny szeregu dążył do zera, czyli</p>
            <p><MathJax math={'`lim_(n to infty) u_n = 0.`'}/></p>
            <br/><br/>

            <h2>Typy szeregów:</h2>
            <h3>Szereg geometryczny</h3>
            {/*<p className='oneLine centerVertical'>
                <div className='column'><sup className='nospace'>&#8734;</sup> &#8721; <sub>n=1</sub></div>
                aq<sup><small>n-1</small></sup> &nbsp;&nbsp; lub &nbsp; a+aq+aq<sup><small>2</small></sup>+...+
                aq<sup><small>n-1</small></sup>
            </p>*/}
            <p><MathJax math={szeregGeo} /></p>
            <p>Szereg geometryczny jest zbieżny, gdy <TeX math={'q'}/>&#8714;&#8804;-1,1&#8805;</p>
            <br/>

            <h3>Szereg harmoniczny rzędu a</h3>
            {/*<p className='oneLine centerVertical'>
                <div className='column'><sup className='nospace'>&#8734;</sup> &#8721; <sub>n=1</sub></div>
                <div className='column'><sup className='nospace'>n+1</sup> <hr className='dwumianOgol'/>
                <sub className='nospace'>n<sup><small>a</small></sup></sub></div>
            </p>*/}
            <p><MathJax math={szeregHarm} /></p>

            <p>Jeżeli <TeX math={'a'}/>&#8804;1 to szereg jest rozbieżny, jeżeli <TeX math={'a'}/>&#62;1 to szereg jest zbieżny.</p>
            <br/><br/>

            <Link to="/analiza/pojecia-wstepne/szeregi-liczbowe/nieujemne"><button>Szeregi o wyrazach nieujemnych</button></Link><br/>
            <Link to="/analiza/pojecia-wstepne/szeregi-liczbowe/przemienne"><button>Szeregi przemienne</button></Link><br/>
        </div>
    );
}